import { createTheme } from "@mui/material/styles";

export const theme = (isDarkMode = false) => {
    const mode = isDarkMode ? "dark" : "light";
    return createTheme({
        palette: {
            mode: mode,
        },
        zIndex: {
            appBar: 1250,
        },
        typography: {
            h4: { fontSize: "1.9rem" },
        },
    });
};

// export const theme = createTheme({
//     palette: {
//         mode: "dark",
//     },
//     zIndex: {
//         appBar: 1250,
//     },
// });
